import React from 'react';

export interface LabelProps {
  htmlFor: string;
  children: React.ReactNode;
  required?: boolean;
  srOnly?: boolean;
  className?: string;
}

const Label: React.FC<LabelProps> = ({
  htmlFor,
  children,
  required = false,
  srOnly = false,
  className = '',
}) => {
  const base = srOnly ? 'sr-only' : 'block text-sm font-medium text-pt-forest mb-1.5';
  return (
    <label htmlFor={htmlFor} className={`${base} ${className}`.trim()}>
      {children}
      {required && (
        <span aria-hidden="true" className="ml-0.5 text-error">
          *
        </span>
      )}
    </label>
  );
};

export default Label;
